<ng-container *ngIf="!isLoading; else loadingTemplate">
  <div class="job-page">
    <div [ngClass]="isMobile ? 'mobile-header' : 'header'">
      <app-external-header
        style="z-index: 1000; position: relative; width: 100%"
        [isInboxPresent]="true"
        [isCompanyProfile]="false"
        [isProfile]="true"
        [isMobile]="isMobile"
        [showButtons]="false"
        [showProfilePicture]="true"
      ></app-external-header>
    </div>

    <div class="main-wrapper">
      <div class="back-button">
        <app-button
          (click)="goBack()"
          [label]="'job_details.back' | translate"
          [size]="isMobile ? ButtonSize.LARGE : ButtonSize.LARGER"
          [state]="ButtonState.REGULAR"
          [type]="ButtonType.GHOST"
        ></app-button>
      </div>

      <div class="main-layout">
        <!-- Left Column: Job Description -->
        <div class="left-column">
          <div class="job-description-card">
            <div class="job-header">
              <div class="job-title-block">
                <h1 class="position">{{ job?.title }}</h1>
                <div class="job-company-info">
                  <img *ngIf="job?.companyLogoUrl" [src]="job?.companyLogoUrl" alt="Company Logo" class="company-logo"/>
                  <p class="company">{{ job?.companyName }}</p>
                  <p class="posted-date">{{ getTimeAgo(job?.createdAt) }}</p>
                </div>
              </div>
            </div>

            <!-- Job Description -->
            <h2>{{ 'job_details.sections.description' | translate }}</h2>
            <p>{{ job?.description }}</p>


            <h2>{{ 'options.qualifications' | translate }}</h2>
            <p>{{ job?.qualifications }}</p>
          </div>

          <div class="about-company-card">
            <div class="about-company-header">
              <img *ngIf="job?.companyLogoUrl" [src]="job?.companyLogoUrl" alt="Company Logo" class="company-logo"/>
              <h3>{{ 'job_details.sections.aboutCompany' | translate }}</h3>
              <p>{{ description }}</p>
            </div>
          </div>
        </div>

        <div class="right-column">
          <div class="details-card">
            <h3>{{ 'job_details.sidebar.job_description' | translate }}</h3>
            <p><strong>{{ 'job_details.sidebar.location' | translate }}:</strong> {{ job?.location }}</p>
            <p><strong>{{ 'job_details.sidebar.salary' | translate }}:</strong> {{ job?.salaryRange }}</p>
            <p><strong>{{ 'job_details.sidebar.experience' | translate }}:</strong> {{ job?.experience }}</p>

            <app-button
              class="apply-button"
              (click)="applyForJob()"
              [label]="'job_details.sidebar.apply' | translate"
              [size]="ButtonSize.LARGE"
              [state]="ButtonState.REGULAR"
              [type]="ButtonType.PRIMARY"
            ></app-button>
          </div>

          <div class="additional-info-card">
            <h3>{{ 'job_details.sidebar.additionalInfo' | translate }}</h3>
            <ng-container>
              <div style="display: flex;gap: 0.5rem;">
                <p><strong>{{ 'job_details.sidebar.language' | translate }}:</strong></p>
                <div class="language-tag">
                  <div>{{ job?.languageLevel }}</div>
                </div>
              </div>
            </ng-container>

            <p><strong>{{ 'job_details.sidebar.tags' | translate }}:</strong></p>
            <div class="tag-list">
              <span class="tag" *ngFor="let tag of job?.tags">{{ tag }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
  </div>

</ng-container>
<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
